import React, { useEffect, useState } from "react";
import moment from 'moment';
import ReactTable from "react-table";
import Button from "components/CustomButtons/Button.js";
import EmailIcon from '@material-ui/icons/Email';
import {NavLink} from "util/router";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container'
import EditClassButton from 'components/Store/EditClassButton'
import DeleteClassButton from 'components/DeleteClassButton'
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import ShareIcon from '@material-ui/icons/Share';
import ShareButton from 'components/ShareButton'
import { useSelector } from 'react-redux';
import {useRouter} from 'util/router'
import ReactDOM from 'react-dom'
import {CSVLink, CSVDownload} from 'react-csv';
import PeopleIcon from '@material-ui/icons/People';
import "./ClassesTable.scss";

function ClassesTable(props) {

    const router = useRouter()

    let classes = useSelector(state => state.instructor.classes);
    const widgetName = useSelector(state => state.instructor?.instructor?.widgetName)
    const user = useSelector(state => state.user.userData)
    const { showPrevious, challengeid } = props;
    // console.log("JOSH MATCH")
    // console.log(baseUrl)
    

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday at] LT',
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do [at] LT'
        }
    });
    const data = classes
        .filter(val => {
            if (showPrevious) {
                return val.start_time < moment().unix();
            } else {
                return (val.start_time + (val.duration * 60)) > moment().unix();
            }
        })
        .filter(val => {
            if (challengeid) {
                return val.challengeId === challengeid
            }
            return true
        })
        .sort( (a, b) => {
            if (showPrevious) {
                if (a.start_time && b.start_time) {
                    return b.start_time - a.start_time;
                }
            } else {
                if (a.start_time && b.start_time) {
                    return a.start_time - b.start_time;
                }
            }
            return 0
        })
      .map(val => {
        // let date = moment(val.start_time * 1000).format('MMMM Do, h:mm a')
        // var status = ""
        // var color = ""
        // if (val.hidden) {
        //     // yellow "#fbeeca"
        //     status = "Hidden"
        //     color = "#6c757d"
        // } else if (val.expirationDate && val.expirationDate < moment().unix()) {
        //     status = "Expired"
        //     color = "#db7f6d"
        // } else {
        //     status = "LIVE"
        //     color = "#dae8cc"
        // }
        // if (val?.experience_type?.toLowerCase() === "appointment")
        var specialBlock = null
        let isChallenge = val.challengeId ? true : false
        if (isChallenge) {
            specialBlock = (
                <div style={{
                    backgroundColor: "#fbeeca",
                    color: "black",
                    borderRadius: "4px"
                  }}
                  className="px-2 py-1 mr-2"
                  >
                    <PeopleIcon style={{color: "#6c757d"}} />
                </div>
            )
        } else if (val?.experience_type?.toLowerCase() === "appointment") {
            specialBlock = (
                <div style={{
                    backgroundColor: "#db7f6d",
                    color: "black",
                    borderRadius: "4px"
                  }}
                  className="px-2 py-1 mr-2"
                  >
                    Private
                </div>
            )
        }
        
        let key = val.platformID
        let accessLink = val.content_link ?? val.reserve_link ?? "unkown";
        let shareLink = `https://sutrapro.com/${widgetName}/checkout/${val.platformID}`
        const pathName = `${router.pathname}/class/${key}`
        return {
            classTimeAndPath: {
                class_time: val.start_time,
                pathName: pathName,
            },
            
            object: val,
            id: val.platformID,
            
            accessLink: accessLink,
            host_name: val.host_name,
            class_name: val.name,
            name: (
                <div
                className="d-flex d-row align-items-center"
                >
                    <div
                    className="mr-2"
                    // to={pathName}
                    >
                        {val.name ?? val.class_name}
                    </div>
                    {specialBlock}

                </div>
                
            ),
            number_of_reservations: (
                <div className="m-auto text-center">
                    <NavLink
                    className="mr-2"
                    to={pathName}
                    >
                        {val.total_booked ? val.total_booked : "-"}
                        {/* {String(reservationsMap[key] ?? "-") } */}
                    </NavLink>
                </div>
            ),
            location: (
                <div className="d-flex d-row align-items-center">
                    <input
                    style={{paddingRight: "50px"}}
                    type="text" value={accessLink} readOnly={true} className={"form-control"}/>
                    <ShareButton link={accessLink} 
                    style={{marginLeft: "-50px"}}
                    />
                </div>
            ),
            share: (
                <div className="d-flex d-row align-items-center">
                    <input
                    style={{paddingRight: "50px"}}
                    type="text" value={shareLink} readOnly={true} className={"form-control"}/>
                    <ShareButton link={shareLink}
                    style={{marginLeft: "-50px"}}
                    />
                    
                </div>
            ),
            id: (
                <div className="d-flex d-row align-items-center">
                    <input
                    style={{paddingRight: "50px"}}
                    type="text" value={val.platformID} readOnly={true} className={"form-control"}/>
                    <ShareButton link={val.platformID}
                    style={{marginLeft: "-50px"}}
                    />
                    
                </div>
            ),
            actions: val.instructor_id === user.platformID ? (
                // we've added some custom button actions
                //val.start_time > moment().unix()
                <div className="d-flex d-row justify-content-end">

                    {/* <IconButton onClick={() => history.push(`${baseUrl}/class/${key}`)}>
                        <VisibilityIcon />
                    </IconButton> */}
                    <EditClassButton 
                    {...props}
                    toEdit={val}
                    new
                    />
                    <DeleteClassButton 
                    classToDelete={val}
                    />
                </div>
              ) : <></>
          };
      })

      function handleExport() {
        const headers = [
          
          {label: "Start time", key: "class_start_time"},
          {label: "Access Link", key: "access_link"},
          {label: "Name", key: 'name'}
        //   {label: "Marketing Opt-in", key: "agree_to_marketing"},
        //   {label: "Current Status", key: "status"},
        //   {label: "Username", key: "username"},
        //   {label: "Region", key: "region"},
        //   {label: "Birthday Month", key: "birthdayMonth"},
        //   {label: "Injuries", key: "injuries"},
        //   {label: "Special Requests", key: "specialRequests"},
          
          // {label: "Date Booked", key: "date_booked"},
          // {label: "Sales", key: "sales"},
          // {label: "Class Name", key: "class"},
          // {label: "Class Time", key: "class_time"}
        ]
        const cleanedData = data.map(val => {
          return {
            class_start_time: moment(val.classTimeAndPath.class_time * 1000).format("dddd MMM Do"),
            access_link: val.accessLink,
            name: val.class_name
            
            // date_booked: moment(val.date * 1000).format('MMMM Do, h:mm a'),
            
            // sales: `$${(val.revenue / 100)}`,
            // class: val.class.name,
            // class_time: moment(val.class_time * 1000).format('MMMM Do, h:mm a'),
            // client_name: val.student_name,
            
            // client_email: val.email
          }
        })
        const element = (<CSVDownload filename={`export.csv`} data={cleanedData} headers={headers} target="_blank" />);
 
        ReactDOM.render(element, document.querySelector('#export-classes-div'));
      }

    return (
        <div>
            
            {/* <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                    ...
                    </div>
                </div>
            </div> */}
            {/* <Modal
            // className={"modal-container custom-map-modal"}
            size="lg"
            {...props}
            show={editorOpen}
            onHide={ () => setEditorOpen(false)}
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Container>
                <ServiceEditor
                {...props}
                sendingUrl={match.url}
                editClassMode={true}
                // editMode={true}
                // existingService={existingService}
                />
                </Container>
                
            </Modal> */}
            {/* <div className="d-flex flex-row-reverse">
                <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
                <div id='export-classes-div'></div>
            </div> */}
            <ReactTable
                    data={data}
                    filterable={false}
                    columns={[
                        // {
                        //     Header: "Id",
                        //     accessor: "id",
                        //     minWidth: 250
                        // },
                        {
                        Header: "Date",
                        accessor: "classTimeAndPath",
                        // filterable: false,
                        // sort: 'desc',
                        sortMethod: (a,b) => {
                            return a.class_time - b.class_time
                        },
                        Cell: row => (
                            <NavLink 
                            to={row.value.pathName}>
                                <div>{moment(row.value.class_time * 1000).format("dddd MMM Do")}</div>
                                <div>{moment(row.value.class_time * 1000).format("h:mm a")}</div>
                            </NavLink>
                        ),
                        width: 180
                        },
                        {
                        Header: "# Booked",
                        accessor: "number_of_reservations",
                        width: 100
                        },
                        {
                        Header: "Instructor",
                        accessor: "host_name",
                        minWidth: 80
                        },
                        // {
                        // Header: "Time",
                        // accessor: "class_time",
                        // filterable: false,
                        // sort: 'desc',
                        // Cell: row => <span>{moment(row.value * 1000).format("LT")}</span>
                        // },
                        {
                        Header: "Name",
                        accessor: "name",
                        width: 180
                        },
                        {
                        Header: "Access link",
                        accessor: "location",
                        minWidth: 140
                        },
                        {
                        Header: "Share link",
                        accessor: "share",
                        minWidth: 140
                        },
                        {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        width: 100
                        // filterable: false
                        }
                    ]}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom={true}
                    className="-highlight"
                    // getTrProps={(state, rowInfo) => ({
                    //     onClick: () => {
                    //         console.log(`State: `)
                    //         console.log(state)
                    //         console.log(`RowInfo:`)
                    //         console.log(rowInfo)
                    //     }
                    // })}
                    />
        </div>
    );
}

export default ClassesTable;